import { WebPlugin } from '@capacitor/core';
export class CapacitorPassToWalletWeb extends WebPlugin {
    async addToWallet(options) {
        console.log(options);
        throw new Error('Not supported');
    }
}
//# sourceMappingURL=web.js.map